export default "__VITE_ASSET__417b9af4__"